import {
  BottomSheetContainer,
  Colors,
  createUseBottomSheetModal,
  Flex,
  IconCheck,
  Typography,
  VerticalSpacing,
} from '@banhala/ui-kit';

const SORT_TYPES: { label: string; value: string }[] = [
  { label: '추천순', value: 'RECOMMEND' },
  { label: '인기순', value: 'POPULAR' },
  { label: '최신순', value: 'LATEST' },
  { label: '리뷰 많은순', value: 'MORE_REVIEWS' },
  { label: '낮은 가격순', value: 'LOW_PRICE' },
];

export const convertSortTypeLabel = (value: string) => {
  const found = SORT_TYPES.find(item => item.value === value);
  return found ? found.label : '추천순';
};

export const useSelectSortType = createUseBottomSheetModal<
  {
    selected: string;
  },
  { current: string }
>(({ confirm, param }) => {
  return (
    <BottomSheetContainer>
      <VerticalSpacing size={16} />
      {SORT_TYPES.map(item => {
        const selected = item.value === param.current;
        const color = selected ? 'content_pink_primary' : 'content_primary';

        return (
          <Flex.Row
            key={item.label}
            justifyContent={'space-between'}
            padding={{ horizontal: 16, vertical: 16 }}
            onPress={() => {
              confirm({ selected: item.value });
            }}
          >
            <Typography type={selected ? 'subtitle1' : 'body1'} color={color}>
              {item.label}
            </Typography>
            {selected && (
              <IconCheck
                width={20}
                height={20}
                fill={Colors.content_pink_primary}
              />
            )}
          </Flex.Row>
        );
      })}
    </BottomSheetContainer>
  );
});
